import React from 'react';
import './Hero.css';

const Hero = () => {
    return (
       
            
                <div className="academics-strip">
                    <h2 className="hero-title">Academics</h2>
                </div>
              

               
    );
};

export default Hero;
